// The listeners sit on document: the modal injects its own drill links outside
// this element.

import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['overlay', 'page'];

  connect() {
    this.onClick    = event => { if (event.target.closest('a[data-page-spinner]')) this.load() }
    this.onSubmit   = event => { if (event.target.matches('form[data-page-spinner]')) this.load() }
    // Back/forward restores from cache: never leave the spinner up.
    this.onRestore  = () => this.settle()

    document.addEventListener('click', this.onClick)
    document.addEventListener('submit', this.onSubmit)
    document.addEventListener('turbolinks:load', this.onRestore)
    window.addEventListener('pageshow', this.onRestore)

    if (this.data.get('open-filter') === 'true') this.openFilter()
  }

  disconnect() {
    document.removeEventListener('click', this.onClick)
    document.removeEventListener('submit', this.onSubmit)
    document.removeEventListener('turbolinks:load', this.onRestore)
    window.removeEventListener('pageshow', this.onRestore)
  }

  print() {
    window.print()
  }

  openFilter() {
    if (typeof showModal === 'function') showModal('#filter-profitability')
  }

  load()   { this.toggle(true) }
  settle() { this.toggle(false) }

  toggle(loading) {
    if (!this.hasOverlayTarget || !this.hasPageTarget) return

    this.overlayTarget.classList.toggle('d-none', !loading)
    this.pageTarget.classList.toggle('d-none', loading)
    if (loading && window.$) $('.modal.show, .modal.in').modal('hide')
  }
}
